import type { FaireProductEntity } from "../../entity_types/product";

export const p_9xss4bj9n6: FaireProductEntity = {
  token: "p_9xss4bj9n6",
  type: "product",
  name: "Weirdo Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/2fb854773f4fd324f5ba0a23d090ff7d802a9defa3b45dbd8bcb6e38ff9a5acf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72bb4a1de2e8173f22b6919776a7ec3698f612a7106ecf7a590369d91e7dbcf8.jpeg",
    "https://cdn.faire.com/fastly/b539461e5c786deadd00407007a45db549a025e52125e3b3c9a4ca3f7623cf25.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/7485ce6f30e90582f58ec33e42fb62e455791c6a29d938c5caa2ab5ad63ac0bf.jpeg",
    "https://cdn.faire.com/fastly/ac74ae73e8df342cb58a4cbd6ec1ad1abbbbeeb906475e0818621d49b0237c62.jpeg"
  ],
  priceDollars: 6.75,
  description: "You're niche, but interesting, you're strange, but fascinating. You need socks that tell the full story.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:13.142Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
